import React from 'react';
import { styled } from '../../../../../shared/Theme/theme';
import { lookupAccountingState } from './accountingStateCatalog';

type Props = {
    /** accountingState code from the shipment (e.g. 'INVOICE_SENT'). */
    code: string | null | undefined;
};

const NEUTRAL = { color: '#6b7280', label: '—' } as const;

const StatusPill = ({ code }: Props) => {
    const entry = lookupAccountingState(code);
    const dotColor = entry?.color ?? NEUTRAL.color;
    const label = entry?.name ?? NEUTRAL.label;

    return (
        <Pill title={label}>
            <Dot style={{ background: dotColor }} />
            <Label>{label}</Label>
        </Pill>
    );
};

const Pill = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 2px 10px 2px 8px;
    border-radius: 12px;
    background: #f4f6f8;
    color: #374151;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    min-height: 22px;
    max-width: 240px;
    white-space: nowrap;
`;

const Dot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex: 0 0 auto;
`;

const Label = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default StatusPill;
